// Français pour la coquille : les groupes de navigation, les titres de page, la barre supérieure. Enregistré au chargement.
import { registerFr } from '../i18n/index.js';

registerFr({
  'Overview': 'Vue d’ensemble',
  'CRM': 'CRM',
  'Engagement': 'Mandat',
  'System': 'Système',
  '— no engagement —': '— aucun mandat —',
  'Toggle theme': 'Changer de thème',
  'Toggle sidebar': 'Afficher/masquer la barre latérale',
  'Open menu': 'Ouvrir le menu',
  'Close menu': 'Fermer le menu',
  'Active engagement': 'Mandat actif',
  'Log out': 'Se déconnecter',
}, 'AppShell');
